import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import { TooltipProvider } from "./components/ui/tooltip";
import { ThemeProvider } from "./components/layout/theme-provider";
import "./index.css";
import Index from "./pages";
import Dashboard from "./pages/dashboard";
import Register from "./pages/register";
import Contact from "./pages/contact";
import Inventory from "./pages/inventory";
import SalePage from "./pages/transactions/sale";
import PurchasePage from "./pages/transactions/purchase";
import UsersPage from "./pages/manage/users";
import CategoriesPage from "./pages/manage/categories";
import ProductsPage from "./pages/manage/products";
import VendorsPage from "./pages/manage/vendors";
import PurchaseReportPage from "./pages/analytics/purchase";
import SaleReportPage from "./pages/analytics/sale";
import StockReportPage from "./pages/analytics/stock";
import ProfitReportPage from "./pages/analytics/profit";
import Settings from "./pages/settings";
import { AuthProvider } from "./context/AuthContext";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ThemeProvider defaultTheme="light" attribute="class">
          <BrowserRouter>
            <Routes>
              <Route path='/' element={<Index />} />
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='/register' element={<Register />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/inventory' element={<Inventory />} />
              <Route path='/settings' element={<Settings />} />
              <Route path='/transactions/sale' element={<SalePage />} />
              <Route path='/transactions/purchase' element={<PurchasePage />} />
              <Route path='/analytics/purchase' element={<PurchaseReportPage />} />
              <Route path='/analytics/sale' element={<SaleReportPage />} />
              <Route path='/analytics/stock' element={<StockReportPage />} />
              <Route path='/analytics/profit' element={<ProfitReportPage />} />
              <Route path='/manage/users' element={<UsersPage />} />
              <Route path='/manage/categories' element={<CategoriesPage />} />
              <Route path='/manage/products' element={<ProductsPage />} />
              <Route path='/manage/vendors' element={<VendorsPage />} />
              {/* Redirect /login to the home page since it has the login form */}
              <Route path='/login' element={<Index />} />
            </Routes>
          </BrowserRouter>
          <Sonner />
          <Toaster />
        </ThemeProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </AuthProvider>
);